import axios from "axios"
import { Apis } from "constants/apis";

const getSiteSettingsByKey = async(payload: any) => {
    const { data } = await axios.post(Apis.GET_SITE_SETTINGS_BY_KEY, payload)
    return data
}

export default getSiteSettingsByKey